import UserSessionService from "./UserSessionService";
import BasicAuthGenerator from "../utils/BasicAuthGenerator";
import RawWsService from "./RawWsService";

const ENDPOINT_BASE = "/admin/transacting-partner-config";

export default class TransactingPartnerConfigService {

    static retrieveConfigByRemittancePartner(remittancePartner) {
        let endpoint = ENDPOINT_BASE + "?remittance-partner=" + remittancePartner;
        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"])
        };

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return response.body;
            },
            response => {
                return response;
            });
    }
}
